import { Dialog, Box, Card } from '@mui/material';
import styled from 'styled-components';

export const StyleDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: 50vw;
    width: 50vw;
    min-height: 70vh;
    height: 70vh;
    margin: 0;
    border-radius: 10px;
    background-color: #f5f6f8;
  }
`;

export const StyledCard = styled(Card)<{ selected: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? 'rgba(0, 123, 255, 0.1)' : '#F6F4F4')};
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  &:hover {
    background-color: rgba(0, 123, 255, 0.1);
  };
`;

export const StyledBox = styled(Box)<{ selected: boolean }>`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? 'rgba(257, 47, 107, 0.47)' : 'transparent')};
  border: 1px solid #FE2F67;
`;

export const StyledButton = styled.button`
  border-radius: 5px;
  border: none;
  height: 8px;
  display: flex;
  align-items: center;
  margin-right: 1em;
  padding: 20px 30px;
  color: white;
  background-color: #FF2D55;
  &:hover {
    cursor: pointer;
    background-color: #ff4869;
  }
`;
